import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRedirectLink = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 12,
	viewBox: "0 0 11 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.5 6.5V9.5C8.5 9.76522 8.39464 10.0196 8.20711 10.2071C8.01957 10.3946 7.76522 10.5 7.5 10.5H2C1.73478 10.5 1.48043 10.3946 1.29289 10.2071C1.10536 10.0196 1 9.76522 1 9.5V4C1 3.73478 1.10536 3.48043 1.29289 3.29289C1.48043 3.10536 1.73478 3 2 3H5M7 1.5H10M10 1.5V4.5M10 1.5L4.5 7",
		stroke: "#4C5AFF",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgRedirectLink;
